// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.source-admin {
  width: min(92vw, 460px);
  max-height: 82vh;
  background: #1c2c40;
  border: 1px solid #4a9eff;
  border-radius: 10px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.source-admin__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.1rem 1.3rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
}

.source-admin__title {
  margin: 0;
  color: #fff;
  font-size: 1.2rem;
}

.source-admin__close {
  background: none;
  border: none;
  color: #9fb4cc;
  font-size: 1rem;
  cursor: pointer;
  line-height: 1;
  padding: 0.3rem;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.source-admin__close .icon { width: 1.1rem; height: 1.1rem; }

.source-admin__close:hover {
  background: #23384f;
  color: #fff;
}

.source-admin__body {
  padding: 1.1rem 1.3rem;
  overflow-y: auto;
  color: #cdd8e6;
  /* Match the app's shared dark-theme scrollbar (see styles.css). */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;
}

.source-admin__body::-webkit-scrollbar {
  width: 8px;
}

.source-admin__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.source-admin__body::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}

.source-admin__hint {
  margin: 0 0 0.9rem;
  font-size: 0.82rem;
  color: #9fb4cc;
  line-height: 1.5;
}

.source-admin__status {
  padding: 0.6rem 0;
  color: #9fb4cc;
  font-size: 0.9rem;
}

.source-admin__error {
  padding: 0.6rem 0.8rem;
  margin-bottom: 0.8rem;
  background: rgba(255, 92, 92, 0.12);
  border: 1px solid rgba(255, 92, 92, 0.4);
  border-radius: 6px;
  color: #ff9b9b;
  font-size: 0.85rem;
}

.source-admin__list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.source-admin__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid rgba(74, 158, 255, 0.12);
}

.source-admin__row:last-child { border-bottom: none; }

.source-admin__name {
  color: #e6eef8;
  font-size: 0.9rem;
}

.source-admin__switch {
  position: relative;
  flex: 0 0 auto;
  width: 42px;
  height: 24px;
  border: none;
  border-radius: 12px;
  background: #3a4a5f;
  cursor: pointer;
  transition: background 0.2s;
  padding: 0;
}

.source-admin__switch:disabled {
  opacity: 0.6;
  cursor: default;
}

.source-admin__switch--on {
  background: #4a9eff;
}

.source-admin__switch-knob {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.2s;
}

.source-admin__switch--on .source-admin__switch-knob {
  transform: translateX(18px);
}

.source-admin__footer {
  display: flex;
  justify-content: flex-end;
  padding: 0.9rem 1.3rem;
  border-top: 1px solid rgba(74, 158, 255, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/components/source-admin-panel/source-admin-panel.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,6BAA6B,aAAa,EAAE,cAAc,EAAE;;AAE5D;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kEAAkE;EAClE,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA,gCAAgC,mBAAmB,EAAE;;AAErD;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C","sourcesContent":[".source-admin {\r\n  width: min(92vw, 460px);\r\n  max-height: 82vh;\r\n  background: #1c2c40;\r\n  border: 1px solid #4a9eff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.55);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.source-admin__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 1.1rem 1.3rem;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n\r\n.source-admin__title {\r\n  margin: 0;\r\n  color: #fff;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.source-admin__close {\r\n  background: none;\r\n  border: none;\r\n  color: #9fb4cc;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  line-height: 1;\r\n  padding: 0.3rem;\r\n  border-radius: 6px;\r\n  transition: background 0.2s, color 0.2s;\r\n}\r\n\r\n.source-admin__close .icon { width: 1.1rem; height: 1.1rem; }\r\n\r\n.source-admin__close:hover {\r\n  background: #23384f;\r\n  color: #fff;\r\n}\r\n\r\n.source-admin__body {\r\n  padding: 1.1rem 1.3rem;\r\n  overflow-y: auto;\r\n  color: #cdd8e6;\r\n  /* Match the app's shared dark-theme scrollbar (see styles.css). */\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.25) transparent;\r\n}\r\n\r\n.source-admin__body::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.source-admin__body::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n.source-admin__body::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.35);\r\n}\r\n\r\n.source-admin__hint {\r\n  margin: 0 0 0.9rem;\r\n  font-size: 0.82rem;\r\n  color: #9fb4cc;\r\n  line-height: 1.5;\r\n}\r\n\r\n.source-admin__status {\r\n  padding: 0.6rem 0;\r\n  color: #9fb4cc;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.source-admin__error {\r\n  padding: 0.6rem 0.8rem;\r\n  margin-bottom: 0.8rem;\r\n  background: rgba(255, 92, 92, 0.12);\r\n  border: 1px solid rgba(255, 92, 92, 0.4);\r\n  border-radius: 6px;\r\n  color: #ff9b9b;\r\n  font-size: 0.85rem;\r\n}\r\n\r\n.source-admin__list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.source-admin__row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding: 0.65rem 0;\r\n  border-bottom: 1px solid rgba(74, 158, 255, 0.12);\r\n}\r\n\r\n.source-admin__row:last-child { border-bottom: none; }\r\n\r\n.source-admin__name {\r\n  color: #e6eef8;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.source-admin__switch {\r\n  position: relative;\r\n  flex: 0 0 auto;\r\n  width: 42px;\r\n  height: 24px;\r\n  border: none;\r\n  border-radius: 12px;\r\n  background: #3a4a5f;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n  padding: 0;\r\n}\r\n\r\n.source-admin__switch:disabled {\r\n  opacity: 0.6;\r\n  cursor: default;\r\n}\r\n\r\n.source-admin__switch--on {\r\n  background: #4a9eff;\r\n}\r\n\r\n.source-admin__switch-knob {\r\n  position: absolute;\r\n  top: 3px;\r\n  left: 3px;\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  transition: transform 0.2s;\r\n}\r\n\r\n.source-admin__switch--on .source-admin__switch-knob {\r\n  transform: translateX(18px);\r\n}\r\n\r\n.source-admin__footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 0.9rem 1.3rem;\r\n  border-top: 1px solid rgba(74, 158, 255, 0.2);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
